// src/GalleryPage.jsx
import React, { useState, useEffect } from 'react';
import PageHeader from './PageHeader';
import styles from './GalleryPage.module.css';
import axios from 'axios';

const API_BASE_URL= 'https://kigaawater.inkenya.co.ke/api'; 

const SERVER_URL = 'https://kigaawater.inkenya.co.ke';

const GalleryPage = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/gallery`);
        setImages(response.data);
      } catch (error) {
        console.error('Failed to fetch gallery images', error);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className={styles.container}>
      <PageHeader
        title="Gallery"
        subtitle="Moments from our journey."
      />

      <section className={styles.section}>
        <div className={styles.grid}>
          {images.map((img, index) => (
            <img 
	key={img.id} 
        src={`${SERVER_URL }${img.image_url}`}  // ← Use 	image_url, prepend API base
        alt={img.caption || `Gallery ${index + 1}`} 
        className={styles.image}	    />
          ))}
        </div>
      </section>

      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Kigaa Self-Help Water Society.</p>
      </footer>
    </div>
  );
};

export default GalleryPage;